import { render, staticRenderFns } from "./relClientAddDialog.vue?vue&type=template&id=c059950a"
import script from "./relClientAddDialog.vue?vue&type=script&lang=js"
export * from "./relClientAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports